/**
 * customização: carrossel com CSS Scroll Snap nativo + barra de progresso (Regras #10/#12).
 * Reaproveitado na home (Featured Products) e alinhado à lógica da Fase 2 (You'll Also Love).
 */
class NativeCarousel extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.track = this.querySelector('[data-carousel-track]');
    this.progressFill = this.querySelector('[data-carousel-progress-fill]');
    if (!this.track) return;

    this._onScroll = () => this.updateProgress();
    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    this.updateProgress();

    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => this.updateProgress());
      this._resizeObserver.observe(this.track);
    }

    window.addEventListener('resize', this._onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    this._resizeObserver?.disconnect();
  }

  updateProgress() {
    if (!this.progressFill || !this.track) return;

    const max = this.track.scrollWidth - this.track.clientWidth;
    const pct = max > 0 ? (this.track.scrollLeft / max) * 100 : 0;
    this.progressFill.style.width = `${Math.max(0, Math.min(100, pct))}%`;
  }
}

if (!customElements.get('native-carousel')) {
  customElements.define('native-carousel', NativeCarousel);
}
